// RecipeNotes.jsx — the ritual's 📝 Notes block on every recipe card:
// what the cup should taste like, plus tomorrow's pre-planned grind move
// ("if bitter → 5.9 · if flat → 5.2"), computed deterministically up front
// (docs/chatgpt-morning-coffee-transcript.md). No AI call — planNextMoves uses
// the same magnitudes the tweak engine applies, on the user's own grinder scale.

import { planNextMoves } from "../lib/coffee.js";

// The standing flavor target from docs/coffee-handoff.md, shown when the bag
// itself carries no tasting notes.
const TARGET = "milk chocolate · caramel · smooth, easy on the stomach";

export function RecipeNotes({ beans = [], brew, grinder = null, className = "" }) {
  if (!brew) return null;
  const notes = [...new Set(
    beans.flatMap((b) => b?.tasting_notes || []).map((n) => String(n).trim().toLowerCase()).filter(Boolean),
  )];
  const expect = notes.length ? notes.join(" · ") : TARGET;
  const { ifBitter, ifFlat } = planNextMoves(brew, grinder);

  return (
    <div className={`rounded-[13px] px-3.5 py-2.5 ${className}`} style={{ background: "rgba(63,74,99,0.05)" }}>
      <div className="font-sf text-[10.5px] font-bold uppercase tracking-[0.06em] text-pronto-text-3 mb-1">
        What to expect
      </div>
      <div className="font-sf text-[12.5px] text-pronto-ink leading-snug capitalize">{expect}</div>
      {(ifBitter != null || ifFlat != null) && (
        <div className="font-sf text-[11.5px] text-pronto-text-2 mt-1.5 leading-snug">
          Tomorrow's move, already planned:
          {ifBitter != null && <> bitter → grind <b className="text-pronto-ink">{ifBitter}</b></>}
          {ifBitter != null && ifFlat != null && <> · </>}
          {ifFlat != null && <> flat → grind <b className="text-pronto-ink">{ifFlat}</b></>}
        </div>
      )}
    </div>
  );
}
